export enum InspectionsActionType {
  SET_INSPECTIONS = 'SET_INSPECTIONS',
  SET_CERTAIN_INSPECTIONS = 'SET_CERTAIN_INSPECTIONS',
  SET_INSPECTIONS_AFTER_SCROLL = 'SET_INSPECTIONS_AFTER_SCROLL',
  SEARCH_INSPECTIONS = 'SEARCH_INSPECTIONS',
  SET_INSPECTIONS_PAGINATION = 'SET_INSPECTIONS_PAGINATION',
  SET_INSPECTIONS_LOADING_STATUS = 'SET_INSPECTIONS_LOADING_STATUS',
  SET_MAP_SIZE = 'SET_MAP_SIZE',
  SET_SMALL_MAP_DIMENSIONS = 'SET_SMALL_MAP_DIMENSIONS',
}
